import { withSuspense } from "@/utils/hoc/withSuspense";

export interface IFolderModal<TAction> {
  folder: {
    id: number;
    name: string;
    qrCount?: number | null;
    subfolders?: { qrCount?: number | null }[] | null;
  };
  show: boolean;
  handleClose: () => void;
  onAction: TAction;
  isActionLoading?: boolean;
}

export const RenameFolderModalLazy = withSuspense(
  () => import("./RenameFolderModal")
);

export const CreateFolderModalLazy = withSuspense(
  () => import("./CreateFolderModal")
);

export const CreateSubfolderModalLazy = withSuspense(
  () => import("./CreateSubfolderModal")
);

export const DownloadFolderModalLazy = withSuspense(
  () => import("./DownloadFolderModal")
);

export const DeleteFolderModalLazy = withSuspense(
  () => import("./DeleteFolderModal")
);

export const MoveSubfolderModalLazy = withSuspense(
  () => import("./MoveSubfolderModal")
);
